export default "__VITE_ASSET__44e2bed0__"